import {Size} from '../../../../generated/types';

const SIZE_ORDER: Size[] = [Size.Tiny, Size.Small, Size.Medium, Size.Large, Size.Huge, Size.Gargantuan];

const CARRY_MULTIPLIERS: Record<Size, number> = {
	[Size.Tiny]: 7.5,
	[Size.Small]: 15,
	[Size.Medium]: 15,
	[Size.Large]: 30,
	[Size.Huge]: 60,
	[Size.Gargantuan]: 120,
};

const PUSH_DRAG_LIFT_FACTOR = 2;

export type CarryingCapacity = {
	/** размер, по которому считается грузоподъёмность: с учётом Могучего телосложения */
	size: Size;
	strength: number;
	/** фунтов на единицу Силы для переносимого веса */
	multiplier: number;
	carry: number;
	pushDragLift: number;
};

export function carryingCapacity(size: Size, strength: number, sizeBonus: number): CarryingCapacity {
	const index = Math.min(SIZE_ORDER.length - 1, Math.max(0, SIZE_ORDER.indexOf(size) + sizeBonus));
	const carryingSize = SIZE_ORDER[index];
	const multiplier = CARRY_MULTIPLIERS[carryingSize];
	return {
		size: carryingSize,
		strength,
		multiplier,
		carry: strength * multiplier,
		pushDragLift: strength * multiplier * PUSH_DRAG_LIFT_FACTOR,
	};
}
